import { MddHttpService } from 'app/core';
import { GetAccessToken } from '../oauth';
import { method } from 'lodash';

export class GetBlob {
    static readonly MISSING_ACCESS_TOKEN = 'No access token available for blob request';

    private mddHttpService: MddHttpService;
    private getAccessToken: GetAccessToken;

    constructor(mddHttp: MddHttpService) {
        this.getAccessToken = new GetAccessToken();
        this.mddHttpService = mddHttp;
    }

    execute(url: string): Promise<ArrayBuffer | undefined> {
        const access = this.getAccessToken.execute();
        if (!access) {
            return Promise.reject(new Error(GetBlob.MISSING_ACCESS_TOKEN));
        }

        return this.mddHttpService
            .request<void, ArrayBuffer>(
                {
                    url: url,
                    headers: {
                        Authorization: `Bearer ${access.token}`
                    }
                },
                'blob'
            )
            .then((x) => x.body);
    }

    executePost(url: string, body: any): Promise<ArrayBuffer | undefined> {
        const access = this.getAccessToken.execute();
        if (!access) {
            return Promise.reject(new Error(GetBlob.MISSING_ACCESS_TOKEN));
        }

        return this.mddHttpService
            .request<void, ArrayBuffer>(
                {
                    method: 'POST',
                    url: url,
                    body: body,
                    headers: {
                        Authorization: `Bearer ${access.token}`
                    }
                },
                'blob'
            )
            .then((x) => x.body);
    }
}
